var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVolumeBarGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 2.5,
    height: 7,
    rx: 1.25,
    fill: "#12805C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 2,
    width: 2.5,
    height: 10,
    rx: 1.25,
    fill: "#12805C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    width: 2.5,
    height: 12,
    rx: 1.25,
    fill: "#12805C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumeBarGreen);
export default __webpack_public_path__ + "static/media/icon_volume_bar_green.095652e889a2caa37da0f227d3b92240.svg";
export { ForwardRef as ReactComponent };